import i18n from "../../plugins/i18n.js";
import router from "../../router";

function findAddress(url) {
  let address = [];
  let stringForMachaer = url.replace(/\/#/, "");
  let matched = router.matcher.match(stringForMachaer).matched;
  if (matched && matched[0]) {
    let reg = /\/(.*)\/:/;
    let reg1 = /\/(.*)/;
    let path = reg.exec(matched[0].path) || reg1.exec(matched[0].path);
    if (path && path[1]) {
      address = path[1].split(/\//);
      return address;
    }
  }
  return address;
}

const state = {
  rootNavigationNode: {
    drawer: false,
    items: [
      {
        title: () => i18n.t("dashboard.dashboard"),
        icon: "mdi-view-dashboard",
        to: "/"
      },
      {
        title: () => i18n.t("analysis.analysis"),
        icon: "mdi-google-analytics",
        to: "/analysis"
      },
      {
        title: () => i18n.t("contacts.contacts"),
        icon: "mdi-contacts",
        to: "/contacts"
      },
      {
        title: () => i18n.t("documents.documents"),
        icon: "mdi-file-document",
        to: "/documents"
      },
      {
        title: () => i18n.t("document-templates.document-templates"),
        icon: "mdi-inbox-full",
        to: {
          name: "DocumentTemplates"
        },
        subTo: [
          {
            name: "DocumentTemplate"
          },
          {
            name: "TemplateLibrary"
          }
        ],
        divider: true
      },
      {
        key: "projects",
        title: () => i18n.t("projects.projects"),
        icon: "mdi-card-bulleted",
        value: false,
        specialTo: { name: "projects" },
        activate: "projects"
      },
      {
        title: () => i18n.t("organizations.organizations"),
        icon: "mdi-briefcase",
        to: "/organizations",
        value: false
      },
      {
        title: () => i18n.t("user-groups.user-groups"),
        icon: "mdi-account-multiple",
        to: "/user-groups",
        value: false
      }
    ],
    navigationNodes: {
      projects: {
        drawer: false,
        items: []
      },
      documents: {
        drawer: false,
        items: []
      }
    }
  }
};

const getters = {
  getRootNavigationNode(state, getters, rootState, rootGetters) {
    let res = state.rootNavigationNode;
    let project = rootGetters["projectStore/getCurrentItem"];
    let isWorkWithCurrentProject =
      rootGetters["projectStore/isWorkWithCurrentProject"];
    let index = res.items.findIndex(x => x.key === "projects");
    if (project && project.id) {
      res.items[index].title = () => project.name;
      res.items[index].to = { name: "project", params: { id: project.id } };
      res.items[index].specialTo.active = true;
      res.activate = "projects";
    } else {
      res.items[index].title = () => i18n.t("projects.projects");
      res.items[index].to = { name: "projects" };
      res.items[index].specialTo.active = false;
      res.activate = "projects";
    }

    let items = getters.getProjectNodeItems;
    res.navigationNodes.projects = {
      items: items,
      drawer:
        !!items.length &&
        state.rootNavigationNode.drawer &&
        isWorkWithCurrentProject
    };
    return res;
  },
  getNavigationNode: (state, getters) => address => {
    let res = getters["getRootNavigationNode"];

    let addressHelper = Array.from(address);

    while (
      addressHelper &&
      addressHelper.length > 0 &&
      res &&
      res.navigationNodes
    ) {
      let newRes = res.navigationNodes[addressHelper.shift()];
      if (newRes) {
        res = newRes;
      } else {
        res;
      }
    }
    return res;
  },
  getProjectNodeItems(state, getters, rootState, rootGetters) {
    let project = rootGetters["projectStore/getCurrentItem"];
    let items =
      Object.keys(project).length > 0
        ? [
            {
              title: () => project.name,
              divider: true,
              icon: "mdi-card-bulleted",
              to: {
                name: "project",
                params: {
                  id: project.id
                }
              },
              specialTo: {
                name: "projects",
                params: {
                  reset: true
                }
              },
              specialIcon: "mdi-close"
            },
            {
              title: () => i18n.t("metering"),
              icon: "mdi-home-analytics",
              items: [
                {
                  title: () => i18n.t("source-adapters.source-adapters"),
                  to: {
                    name: "source-adapters",
                    params: {
                      project_id: project.id
                    }
                  },
                  subTo: [
                    {
                      name: "source-adapter"
                    },
                    {
                      name: "source-adapter-message"
                    }
                  ]
                },
                {
                  title: () => i18n.t("sources.sources"),
                  to: {
                    name: "sources",
                    params: {
                      project_id: project.id
                    }
                  },
                  subTo: {
                    name: "source"
                  }
                },

                {
                  title: () => i18n.t("meters.meters"),
                  to: {
                    name: "meters",
                    params: {
                      project_id: project.id
                    }
                  },
                  subTo: [
                    {
                      name: "meter"
                    },
                    { name: "new-meter" }
                  ]
                },
                {
                  title: () => i18n.t("meter-units.meter-units"),
                  to: {
                    name: "meter-units",
                    params: {
                      project_id: project.id
                    }
                  },
                  subTo: [
                    { name: "meter-unit" },
                    { name: "manage-record" },
                    { name: "new-meter-unit" }
                  ]
                },
                {
                  title: () => i18n.t("ingestions.ingestions"),
                  to: {
                    name: "ingestions",
                    params: {
                      project_id: project.id
                    }
                  },
                  subTo: [{ name: "ingestion" }, { name: "new-ingestion" }]
                },
                {
                  title: () => i18n.t("visualizations.visualizations"),
                  to: {
                    name: "visualizations",
                    params: {
                      project_id: project.id
                    }
                  },
                  subTo: [
                    { name: "visualization" },
                    { name: "new-visualization" }
                  ]
                },
                {
                  title: () => i18n.t("groups.groups"),
                  to: {
                    name: "groups",
                    params: {
                      project_id: project.id
                    }
                  },
                  subTo: [
                    {
                      name: "group"
                    },
                    { name: "NewGroup" }
                  ]
                },
                {
                  title: () => i18n.t("transmissions.transmissions"),
                  to: {
                    name: "transmissions",
                    params: {
                      project_id: project.id
                    }
                  },
                  subTo: {
                    name: "transmission"
                  }
                },
                {
                  title: () => i18n.t("incidents.incidents"),
                  to: {
                    name: "incidents",
                    params: {
                      project_id: project.id
                    }
                  },
                  subTo: {
                    name: "incident"
                  }
                }
              ]
            },
            {
              title: () => i18n.t("accounting"),
              icon: "mdi-account-cash",
              items: [
                {
                  title: () =>
                    i18n.t("consumption-accounting.consumption-accounting"),
                  to: {
                    name: "consumption-accounting",
                    params: {
                      project_id: project.id
                    }
                  }
                },
                {
                  title: () => i18n.t("data-export-upload.exports"),
                  to: {
                    name: "accounting-export",
                    params: {
                      project_id: project.id
                    }
                  }
                },

                {
                  title: () => i18n.t("cost-items.cost-items"),
                  to: {
                    name: "cost-items",
                    params: {
                      project_id: project.id
                    }
                  },
                  subTo: {
                    name: "cost-item"
                  }
                },
                {
                  title: () => i18n.t("contract-periods.contracts"),
                  to: {
                    name: "contract-periods",
                    params: {
                      project_id: project.id
                    }
                  }
                },
                {
                  title: () => i18n.t("billing-periods.billing-periods"),
                  to: {
                    name: "billing-periods",
                    params: {
                      project_id: project.id
                    }
                  }
                },
                {
                  title: () => i18n.t("cost-centres.cost-centres"),
                  to: {
                    name: "cost-centres",
                    params: {
                      project_id: project.id
                    }
                  },
                  subTo: [
                    {
                      name: "cost-centre"
                    },
                    {
                      name: "cost-allocator"
                    },
                    {
                      name: "new-cost-allocator"
                    }
                  ]
                },
                {
                  title: () => i18n.t("tariff-plans.tariff-plans"),
                  to: {
                    name: "tariff-plans",
                    params: {
                      project_id: project.id
                    }
                  },
                  subTo: [{ name: "tariff-plan" }, { name: "new-tariff-plan" }]
                },
                {
                  title: () => i18n.t("tariffs.tariffs"),
                  to: {
                    name: "tariffs",
                    params: {
                      project_id: project.id
                    }
                  },
                  subTo: {
                    name: "tariff"
                  }
                }
              ]
            },
            {
              title: () => i18n.t("settings"),
              icon: "mdi-settings-outline",
              to: {
                name: "project",
                params: {
                  id: project.id,
                  settings: true
                }
              },
              exact: true
            }
          ]
        : [];
    items.map(i => {
      let drawer =
        i.items &&
        i.items.find(i => {
          let subTo = false;
          let currentRoute = router.app.$route.name;
          if (i.subTo) {
            if (Array.isArray(i.subTo)) {
              subTo = !!i.subTo.find(u => u.name === currentRoute);
            } else {
              subTo = !!(i.subTo.name === currentRoute);
            }
          }
          return (i.to && i.to.name === currentRoute) || subTo;
        });
      i.drawer = drawer || false;
      return i;
    });
    return items;
  }
};

const actions = {
  toggleRootNavigationNode({ commit }, { address, url }) {
    if (!address && url) {
      address = findAddress(url);
    }
    commit("toogleRootDrawerForNavigationNode", { address });
  },
  setRootNavigationNode({ commit }, { address, drawer, url }) {
    if (!address && url) {
      address = findAddress(url);
    }
    commit("changeRootDrawerForNavigationNode", { address, drawer });
  },
  activateNavigationNode({ commit }, { address }) {
    commit("changeDrawerForNavigationNode", {
      address,
      drawer: true
    });
  },
  disActivateNavigationNode({ commit }, { address }) {
    commit("changeDrawerForNavigationNode", {
      address,
      drawer: false
    });
  },
  setActivateNavigationNode({ commit }, { address, drawer }) {
    commit("changeDrawerForNavigationNode", { address, drawer });
  }
};
const mutations = {
  changeRootDrawerForNavigationNode: (state, { address, drawer }) => {
    let res = state.rootNavigationNode;
    while (address && address.length > 0 && res && res.navigationNodes) {
      let currentNode = res.navigationNodes[address[0]];
      if (currentNode && currentNode.items.length !== 0 && !res.drawer) {
        res.drawer = drawer;
        res = currentNode;
      }
      address.shift();
    }
    if (res) {
      res.drawer = drawer;
    }
    localStorage.navigation = drawer;
  },
  toogleRootDrawerForNavigationNode(state, { address }) {
    let res = this.getters["navigationStore/getNavigationNode"](address);
    if (res && res.items && res.items.length > 0) {
      this.commit("navigationStore/changeRootDrawerForNavigationNode", {
        address,
        drawer: !(localStorage.navigation === "true")
      });
    } else {
      if (address.length > 0) {
        address.shift();
        this.commit("navigationStore/toogleRootDrawerForNavigationNode", {
          address,
          drawer: !res.drawer
        });
      }
    }
  },
  toogleDrawerForNavigationNode(state, { address }) {
    let res = this.getters["navigationStore/getNavigationNode"]();
    if (res) {
      this.commit("navigationStore/changeDrawerForNavigationNode", {
        address,
        drawer: !res.drawer
      });
    }
  },
  changeDrawerForNavigationNode(state, { address, drawer }) {
    let res = this.getters["navigationStore/getNavigationNode"](address);
    if (res) {
      res.drawer = drawer || false;
    }
    // if is was rootNode
    if (!(address && address.length > 0)) {
      localStorage.navigation = res.drawer;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
